import React from 'react';
// import { Modal } from 'react-bootstrap';
// import 'bootstrap/dist/css/bootstrap.min.css';
import Button from '../button/index';
// import { Link, useHistory } from 'react-router-dom';
import styled from "styled-components";
import Modal from '.';
import { ModalBody, ModalTitle } from './styles';
import { Auxiliar, BodyG, BodyGSpan, H5 } from '../../styles/stylesTypography';
import { theme } from '../../styles/theme';
import ButtonV2 from '../button/button_v2';
import * as S from "./styles"
import ModalImage from '../../assets/modalRecursoClientes.svg';
import maintainUtm from '../../services/maintainUtm';
import { getCurrentPageIdWithDevice } from '../../services/maintainUtm/idPages';


const StyleModal = styled.div`
    p {
        font-family: Lato;
        font-size: 11px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
    }

`;
const StyleModal2 = styled.div`
    p {
        font-family: Lato;
        font-size: 20px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
    }

`;

class ModalNew extends React.Component {
    constructor(props) {
        super(props);
    }


    // updateResponseNo = () => {
    //     let resposta = 0;
    //     this.props.update(resposta);
    // }

    cometoplanos = () => {
        window.location.href = "/planos";
    }

    goToPlans = () => {
        const currentPageId = getCurrentPageIdWithDevice();
        const search = maintainUtm(`${currentPageId}-modalrecursoexclusivo`);
        window.location = `/planos${search}`;
    }

    render() {
        return (

            // <Modal
            //     {...this.props}
            //     size="md"
            //     aria-labelledby="contained-modal-title-vcenter"
            //     centered
            // >
            //     <Modal.Header closeButton style={{backgroundColor: " #f8f8f8", border: 'none'}}>
            //         <Modal.Title id="contained-modal-title-vcenter">

            //         </Modal.Title>
            //     </Modal.Header >
            //     <Modal.Body style={{backgroundColor: " #f8f8f8"}}>
            //         <div style={{ width: '100%', display: 'flex', justifyContent: 'space-around', flexDirection: 'column'}}>
            //             <p style={{fontFamily: 'Lato', fontSize: '22px', fontWeight: 'bold', fontStretch: 'normal', width: '100%', textAlign: 'center', alignSelf: 'center'}}>Você atingiu o limite de impressões gratuitas...</p>
            //             <p style={{color: '#303848', fontFamily: 'Lato', fontSize: '16px', fontWeight: 'normal', width: '100%', textAlign: 'center', alignSelf: 'center'}}>Assine o Agroreceita para desbloquear todos os recursos abaixo:</p>
            //             <p style={{color: '#303848', fontFamily: 'Lato', fontSize: '16px', fontWeight: 'normal', width: '100%', textAlign: 'center', alignSelf: 'center'}}> Emissão de receitas</p>
            //             <p style={{color: '#303848', fontFamily: 'Lato', fontSize: '16px', fontWeight: 'normal', width: '100%', textAlign: 'center', alignSelf: 'center'}}> Controle de Arts</p>
            //             <p style={{color: '#303848', fontFamily: 'Lato', fontSize: '16px', fontWeight: 'normal', width: '100%', textAlign: 'center', alignSelf: 'center'}}> Relatórios completos</p>
            //             <p style={{color: '#303848', fontFamily: 'Lato', fontSize: '16px', fontWeight: 'normal', width: '100%', textAlign: 'center', alignSelf: 'center'}}> Envio de dados para as defesas agropecuárias e CREA SP</p>
            //             <p style={{color: '#303848', fontFamily: 'Lato', fontSize: '16px', fontWeight: 'normal', width: '100%', textAlign: 'center', alignSelf: 'center'}}> Cadastro de produtores e locais de aplicação</p>
            //             <p style={{color: '#303848', fontFamily: 'Lato', fontSize: '16px', fontWeight: 'normal', width: '100%', textAlign: 'center', alignSelf: 'center'}}> Cadastro de responsáveis técnicos</p>
            //             <p style={{color: '#303848', fontFamily: 'Lato', fontSize: '16px', fontWeight: 'normal', width: '100%', textAlign: 'center', alignSelf: 'center'}}> Impressão e consulta de fichas de emergência e FISPQs</p>

            //             <div style={{ marginLeft: '10px', width: '100%', textAlign: 'center', marginTop: '20px', alignSelf: 'center', display: 'flex', justifyContent: 'space-around', flexDirection: 'row-reverse'}}>
            //                 <a style={{ width: "187px", textDecoration: "none" }} href="/planos">
            //                 <Button style={{ outline:0, padding: "5px", width:"166px", height: "45px" }}
            //                     color="#00b43f"
            //                     >ASSINAR AGORA</Button>
            //                 </a>
            //             </div>
            //         </div>

            //     </Modal.Body>
            // </Modal>


            <Modal
                {...this.props}
                align='center' // center, end, start
                justify='center' // center, end, start
                responsive
                width='50%'
            >
                <ModalBody>
                    <S.Container>
                        <img src={ModalImage} alt='Imagem garota olhando um presente' />

                        <H5 color={theme.colors.gray.Cinza_5}>{this.props.title || "Recurso exclusivo para clientes"}</H5>

                        <BodyG color={theme.colors.gray.Cinza_5}>
                            {this.props.subtitle || "Esta função está disponível apenas para clientes. Para desbloquear essa e outras funcionalidades, faça já seu upgrade."}
                        </BodyG>

                        <Auxiliar color={theme.colors.gray.Cinza_6}>
                            Assine para ter Receitas Agronômicas atualizadas, Envio para Defesas, Controle de ART/TRT, Emissão de FISPQ/FDS/Ficha de Emergência, Relatórios e mais.
                        </Auxiliar>

                        <S.ButtonPlans>
                            <ButtonV2
                                width='90%'
                                height='60px'
                                value='Ver Planos'
                                outline={false}
                                disabled={false}
                                onClick={this.goToPlans}
                                loading={false}
                            ></ButtonV2>
                        </S.ButtonPlans>
                    </S.Container>

                </ModalBody>
            </Modal>


        );
    }
}
export default ModalNew;
